/*
  Hygeon — translates Shopify's own sort-option labels (Sortieren
  dropdown/panel on every collection and search page) to German.

  Real bug found 2026-09-29 during a bug-hunt pass: the "Sortieren"
  LABEL itself was already correctly German (locale key actions.sort),
  but every individual OPTION inside it was raw, untranslated English —
  confirmed live via the real <select name="sort_by"> options on
  /collections/papier-hygieneprodukte: "Featured", "Most relevant",
  "Best selling", "Alphabetically, A-Z/Z-A", "Price, low to high/high
  to low", "Date, old to new/new to old". These come from Shopify
  CORE's own results.sort_options[].name (snippets/sorting.liquid,
  {{ option.name }}) — a platform-provided value, not a theme locale
  string, so there's no `| t` translation key in this theme's own
  locales/de.json to fix this from. Same root cause class as the
  /collections/all "Products" heading fixed the same day — a Shopify-
  core default that doesn't follow the shop's own German primary-
  language setting.

  This renders on THREE places per page load (snippets/sorting.liquid):
  the plain <select><option> (mobile, when should_use_select_on_mobile),
  the accordion/radio "sorting-filter__label" spans (desktop/overflow),
  and the compact ".facets__status" text showing the CURRENTLY selected
  option's own name — plus re-renders on every AJAX filter/sort/
  pagination update, same as the overflow-list bug already fixed in
  hygeon-filters-fix.js. Translates by exact string match only (never a
  substring/contains check) specifically so this can never misfire on
  some unrelated filter's own status text that happens to share a word
  — every string here is checked for an exact equal before replacing.
*/
(function () {
  var TRANSLATIONS = {
    // Initial full-page-load render (results.sort_options[].name via
    // snippets/sorting.liquid) — plain English, confirmed live.
    'Featured': 'Empfohlen',
    'Most relevant': 'Relevanz',
    'Relevance': 'Relevanz',
    'Best selling': 'Bestseller',
    'Alphabetically, A-Z': 'Alphabetisch, A-Z',
    'Alphabetically, Z-A': 'Alphabetisch, Z-A',
    'Price, low to high': 'Preis, aufsteigend',
    'Price, high to low': 'Preis, absteigend',
    'Date, old to new': 'Datum, alt zu neu',
    'Date, new to old': 'Datum, neu zu alt',

    // 2026-09-29, found live while testing the AJAX sort-change path:
    // after a filter/sort update, Horizon's Section Rendering API
    // fetch returns a THIRD, different set of strings for the same
    // options — already German, but differently worded and
    // inconsistently cased ("meistverkauft" lowercase) versus the
    // initial-load set above. A genuine Shopify-side inconsistency
    // between the full-page-load and AJAX-partial resolution paths
    // for the same underlying sort_options data, not something this
    // theme controls either side of. Normalized to the exact same
    // canonical wording chosen above so the label never visibly
    // changes wording depending on which path happened to render it.
    'Ausgewählt': 'Empfohlen',
    'Am relevantesten': 'Relevanz',
    'meistverkauft': 'Bestseller',
    'Preis, niedrig nach hoch': 'Preis, aufsteigend',
    'Preis, hoch nach niedrig': 'Preis, absteigend'
  };

  function translateTextNode(el) {
    if (!el || !el.textContent) return;
    var trimmed = el.textContent.trim();
    var translated = TRANSLATIONS[trimmed];
    if (translated && el.textContent !== translated) {
      el.textContent = translated;
    }
  }

  function scan(root) {
    if (!root.querySelectorAll) return;

    root.querySelectorAll('select[name="sort_by"] option').forEach(translateTextNode);
    root.querySelectorAll('.sorting-filter__label').forEach(translateTextNode);
    root.querySelectorAll('.sorting-filter .facets__status').forEach(translateTextNode);

    // The radio variant's own data-option-name attribute mirrors the
    // Liquid-computed `status` var used for the very first server-
    // rendered .facets__status text above — translate it too so a
    // later client-side read of this attribute (if any future script
    // relies on it) sees the same German value, not the stale English
    // source.
    root.querySelectorAll('.sorting-filter__input[data-option-name]').forEach(function (input) {
      var translated = TRANSLATIONS[input.getAttribute('data-option-name')];
      if (translated) input.setAttribute('data-option-name', translated);
    });
  }

  function start() {
    scan(document);

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          scan(node);
        });
        // .facets__status text updates in place (no new node) when the
        // user picks a different sort option — catch that too.
        if (mutation.type === 'characterData' && mutation.target.parentElement) {
          translateTextNode(mutation.target.parentElement);
        }
      });
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
